import type { PostTradeBalances } from '@einhaus/project314-types';

export interface NormalizedPerformanceChartData {
    points: PostTradeBalances[];
    droppedInvalidPointCount: number;
    droppedOutOfOrderPointCount: number;
    replacedDuplicateTimestampCount: number;
}

/**
 * Lightweight Charts requires finite values and strictly increasing timestamps. Historical
 * portfolio curves can contain repeated intratimestamp snapshots and, in older runs, a redundant
 * terminal marker whose timestamp predates the final trade exit.
 */
export function normalizePerformanceChartData(balances: PostTradeBalances[]): NormalizedPerformanceChartData {
    const points: PostTradeBalances[] = [];
    let droppedInvalidPointCount = 0;
    let droppedOutOfOrderPointCount = 0;
    let replacedDuplicateTimestampCount = 0;

    for (const balance of balances) {
        if (!Number.isFinite(balance.balance) || !Number.isFinite(balance.timestamp) || !Number.isInteger(balance.timestamp)) {
            droppedInvalidPointCount++;
            continue;
        }

        const previousPoint = points.at(-1);

        if (previousPoint && balance.timestamp < previousPoint.timestamp) {
            droppedOutOfOrderPointCount++;
            continue;
        }

        if (previousPoint?.timestamp === balance.timestamp) {
            points[points.length - 1] = balance;
            replacedDuplicateTimestampCount++;
            continue;
        }

        points.push(balance);
    }

    return {
        points,
        droppedInvalidPointCount,
        droppedOutOfOrderPointCount,
        replacedDuplicateTimestampCount
    };
}
